import { createFileRoute } from "@tanstack/react-router";

import { TimelineSearchPage } from "@/features/timeline-search/components/timeline-search-page";

export const Route = createFileRoute("/_authed/_dashboard/admin-tools/timeline-search")({
  component: TimelineSearchPage,
});
